import { defineStore } from 'pinia';
export enum EFuncPermissions {
  createEmployee = 'createEmployee', // 创建员工
  employeeList = 'employeeList', // 员工列表
  editEmployee = 'editEmployee', // 编辑员工
  isEnableEmployee = 'isEnableEmployee', // 解封/禁用员工
  deleteEmployee = 'deleteEmployee', // 删除员工
  roleList = 'roleList', // 角色列表
  createRole = 'createRole', // 创建角色
  editRole = 'editRole', // 编辑角色
  deleteRole = 'deleteRole', // 删除角色
  basePermissions = 'basePermissions', // 授权角色基础权限
  dataPermissions = 'dataPermissions', // 授权角色数据权限

  addCustomerGroup = 'addCustomerGroup', // 添加组别
  customerGroupList = 'customerGroupList', // 客服组管理列表
  editCustomerGroup = 'editCustomerGroup', // 编辑客服组
  isEnableCustomerGroup = 'isEnableCustomerGroup', // 封禁/恢复客服组

  customerList = 'customerList', // 客服管理列表
  editCustomer = 'editCustomer', // 编辑客服
  isEnableCustomer = 'isEnableCustomer', // 禁用/恢复客服

  sessionConfig = 'sessionConfig', // 会话配置
  editSessionConfig = 'editSessionConfig', // 更新会话配置
  sessionShunt = 'sessionShunt', // 会话分流
  editSessionShunt = 'editSessionShunt', // 更新会话分流
  UiConfig = 'UiConfig', // UI配置
  editUiConfig = 'editUiConfig', // 更新UI配置
  clientTag = 'clientTag', // 客户标签配置
  editClientTag = 'editClientTag', // 更新客户标签配置

  customerLinkAccess = 'customerLinkAccess', // 客服聊天链接接入
  sdkAccess = 'sdkAccess', // SDK接入

  // ---

  getClientList = 'getClientList', // 获取客户列表
  clientDetail = 'clientDetail', // 客户详情
  talkDetail = 'talkDetail', // 对话详情

  editKnowledge = 'editKnowledge', // 编辑知识库
  deleteKnowledge = 'deleteKnowledge', // 删除知识库
  getKnowledge = 'getKnowledge', // 获取知识库

  addKnowledgePoint = 'addKnowledgePoint', // 添加知识点
  importKnowledgePoint = 'importKnowledgePoint', // 导入知识点
  deleteKnowledgePoint = 'deleteKnowledgePoint', // 删除知识点
  editKnowledgePoint = 'editKnowledgePoint', // 编辑知识点

  getRobot = 'getRobot', // 查询机器人配置
  editRobot = 'editRobot', // 编辑机器人配置

  getCommonPhrase = 'getCommonPhrase', // 查询常用语
  addCommonPhrase = 'addCommonPhrase', // 添加常用语
  importCommonPhrase = 'importCommonPhrase', // 导入常用语
  editCommonPhrase = 'editCommonPhrase', // 编辑常用语
  deleteCommonPhrase = 'deleteCommonPhrase', // 删除常用语
  openCommonPhrase = 'openCommonPhrase', // 常用语开关
}

export enum EMangerLevel {
  admin = 1, // 管理员
  normal = 2, // 普通人
}

export enum EAuthStatus {
  all = 0,
  enable = 1,
  disable = 2,
}

export enum ESeatHandleStatus {
  all = 0,
  online = 1,
  outline = 2,
  disable = 3,
}

const useAuthStore = defineStore('authStore', () => {
  const mangerLevel = ref<EMangerLevel>(null);

  // 页面权限
  const routerPermissions = ref<string[]>(null);

  // 模块权限
  const modulePermissions = ref<string[]>(null);

  // 功能权限
  const funcPermissions = ref<EFuncPermissions[]>(null);

  const sign = ref<string>('');

  /**
   * 重置权限
   */
  const resetPermission = () => {
    routerPermissions.value = null;
    modulePermissions.value = null;
    funcPermissions.value = null;
    sign.value = '';
  };

  return {
    routerPermissions,
    modulePermissions,
    funcPermissions,
    mangerLevel,
    sign,
    resetPermission,
  };
});

export default useAuthStore;
